import { makeStyles } from "@mui/styles"
import { Bold, Regular, SemiBold, remCalc } from "../../utils"

export const projectCategoryStyle = makeStyles((theme) => ({
    tabtitle: {
        fontSize: "0.75rem",
        color: '#4E5A6B',
        fontFamily: Bold,
    },
    tabtitle1: {
        fontSize: "0.75rem",
        color: '#5078E1',
        fontFamily: Bold,
    },
    subtabtitle: {
        fontSize: "0.75rem",
        color: '#4E5A6B',
        fontFamily: Regular,
    },
    subtabtitle1: {
        fontSize: "0.75rem",
        color: '#5078E1',
        fontFamily: Regular,
    },
    selectBack1: {
        backgroundColor: '#F1F7FF',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 22px 10px 16px',
        borderRadius: theme.palette.borderRadius
    },
    selectBack: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
    },
    filterButton: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px"
    },
    createBtn: {
        height: "40px",
        fontSize: remCalc(14),
        fontFamily: SemiBold,
    },
    drawerTitle: {
        fontSize: remCalc(16),
        fontFamily: Bold,
    },
    drawerCreateBtn:{
        height: "48px",
        fontSize: remCalc(14),
        fontFamily: Bold
    },
    drawer:{
        "& .MuiPaper-root":{
            width: 300
        }
    }
}))